import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconStackedBarChart100Axis: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconStackedBarChart100Axis"><Path d="M3 3H4.5V19.5H21V21H3V3ZM7.25 12H8.75V18H7.25V12ZM12.25 10H13.75V18H12.25V10ZM17.25 13H18.75V18H17.25V13ZM17.25 5H18.75V11H17.25V5ZM7.25 5H8.75V10H7.25V5ZM12.25 5H13.75V8H12.25V5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconStackedBarChart100Axis;
